<template>
<!--  <v-dialog fullscreen persistent>
    <template v-slot:activator="{ props }">
      <v-chip v-bind="props" size="small" density="compact" style="font-size: 10px">v.{{ version }} {{ $config.BASE }}</v-chip>
    </template>

    <template v-slot:default="{ isActive }">
      <v-card class="mx-auto">
        <v-img
            class="align-end text-white"
            height="150"
            src="https://gas-kvas.com/grafic/uploads/posts/2023-10/1696522869_gas-kvas-com-p-kartinki-zavod-45.jpg"
            cover
        >
          <v-card-title class="font-weight-bold d-flex justify-space-between">
            <v-row no-gutters>
              <v-col cols="12">
                РАБОЧИЙ СТОЛ<br>
                НУ & ПД
              </v-col>
              <v-col cols="12">
                ООО "ИТЦ"ГАРДИАН" &copy; 2023-2024
              </v-col>
            </v-row>
          </v-card-title>
        </v-img>
        <v-card-text>
          <v-row no-gutters>
            <v-col cols="12" lg="4" class="border-2">
              <v-alert
                  :title="`Что нового в версии ${version}?`"
                  height="100%"
                  border="end"
                  variant="tonal"
                  color="grey"
                  class="d-flex flex-column justify-start"
              >
                <v-sheet v-for="post in prepared.main.changes" :key="post">
                  <p class="font-weight-bold">{{ post.name }}</p>
                  <p>{{ post.description }}</p>
                </v-sheet>
                <v-sheet class="d-flex font-weight-bold">
                  <v-spacer />
                  от {{ prepared.main.date }}
                </v-sheet>
              </v-alert>
            </v-col>
            <v-col cols="12" lg="8">
              <v-expansion-panels>
                <v-expansion-panel v-for="version in prepared.old.reverse()" :key="version" elevation="0">
                  <template v-slot:title>
                    <span class="font-weight-bold">{{ version.name }}&nbsp;</span> ({{version.date}})
                  </template>
                  <template v-slot:text>
                    <p v-for="post in version.changes" :key="post" style="cursor: pointer">
                      {{ post.name }}
                      <v-tooltip
                          activator="parent"
                          location="left"
                          max-width="400"
                      >{{ post.description }}</v-tooltip>
                    </p>
                  </template>
                </v-expansion-panel>
              </v-expansion-panels>
            </v-col>
          </v-row>
        </v-card-text>

        <v-card-actions>
          <v-spacer />
          <v-btn
              rounded="xl"
              variant="tonal"
              color="deep-orange"
              text="ЗАКРЫТЬ"
              @click="isActive.value = false"
          ></v-btn>
        </v-card-actions>
      </v-card>
    </template>
  </v-dialog>-->
  <v-chip v-bind="props" size="small" density="compact" style="font-size: 10px">v.{{ version }} {{ $config.BASE }}</v-chip>
</template>

<script>
export default {
  name: "PatchNotes",
  data() {
    return {
      news: this.$news.news,
      version: this.$config.APP_VERSION,
      rating: 5,
      menu: false,
      labels: ['1', '2', '3', '4', '5'],
    }
  },
  computed: {
    prepared() {
      let data = {
        main: this.news.find(element => element.version === this.version),
        old: this.news.filter(element => element.version < this.version).sort((a,b) => (a.version < b.version) ? 1 : ((b.version < a.version) ? -1 : 0))
      }
      return data
    }
  }
}

</script>

<style scoped>

</style>
